import React, { JSX } from "react";
import { formatPrice, PriceTypes, type Price as Offer } from "../pricing";
import classNames from "classnames";
import { PriceFormat } from "@/cms/sanity.types";
import { Typography } from "@cappelendamm/design-system/react";

export type PriceProps = Partial<Offer> & {
  format?: Omit<PriceFormat, "_type"> | null;
  type?: PriceTypes;
  variant?: "previous-left" | "previous-right";
  regularFontSize?: boolean;
};
export function Price({
  current,
  previous,
  type = "single",
  variant = "previous-right",
  format,
  className,
  regularFontSize = false,
  ...rest
}: PriceProps & JSX.IntrinsicElements["div"]) {
  if (!previous && format?.title) {
    const title = format.title.replace("{price}", formatPrice(current));
    const description = format.description?.replace(
      "{price}",
      formatPrice(current),
    );
    return (
      <Typography
        {...rest}
        as="div"
        variant="title-lg"
        aria-label={`${title} ${description}`}
      >
        {title}
        {description ? (
          <Typography as="div" variant="body-base">
            {description}
          </Typography>
        ) : null}
      </Typography>
    );
  }

  if (!previous)
    return (
      <Typography
        as="div"
        variant={regularFontSize ? "body-base" : "title-lg"}
        {...rest}
      >
        {`${formatPrice(current, type)}`}
      </Typography>
    );

  return (
    <div {...rest} className={classNames(className, "flex items-center gap-2")}>
      <Typography
        as="span"
        variant={regularFontSize ? "body-base" : "title-lg"}
        className={classNames("font-bold text-red-500")}
      >
        {`${formatPrice(current, type)}`}
      </Typography>
      <Typography
        as="span"
        className={classNames(
          "text-sm font-normal text-gray-800",
          "order-last",
        )}
      >
        {`Før ${formatPrice(previous, type)}`}
      </Typography>
    </div>
  );
}
